import { graphql, useStaticQuery } from "gatsby";
    import { PatstoreArticle } from '@types';

const useGetArticle = () => {
    const data = useStaticQuery(graphql`
        query AllArticle {
            allPatstoreArticle {
                edges {
                    node {
                        id
                        
            objectId
    categories
    label
    image
    title
    createdAt
    text
    gallery
    date
    state
    
                    }
                }
            }
        }
    
        `);


    const allArticle: PatstoreArticle[] =
        data.allPatstoreArticle.edges.map(
            (edge: { node: PatstoreArticle }) => edge.node
        ) || [];

    const findArticle: (id: string) => PatstoreArticle | undefined = (id: string) => {
        const result = allArticle.find((item: PatstoreArticle) => item.objectId === id);

        if (!result) {
            return undefined;
        }

        return result;
    };

    return {
        findArticle,
        articles: allArticle,
    };
}; 

export default useGetArticle;
